import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommMirrorIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M2 9.20144C2 14.6096 6.36787 19.0178 11.75 19.0178C17.1321 19.0178 21.5 14.6096 21.5 9.20144C21.5 8.78723 21.1642 8.45144 20.75 8.45144C20.3358 8.45144 20 8.78723 20 9.20144C20 13.7916 16.2933 17.5178 11.75 17.5178C7.20669 17.5178 3.5 13.7916 3.5 9.20144C3.5 8.78723 3.16421 8.45144 2.75 8.45144C2.33579 8.45144 2 8.78723 2 9.20144Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M4.34766 9.20112C4.34766 13.3112 7.65655 16.6524 11.7498 16.6524C15.8431 16.6524 19.152 13.3112 19.152 9.20112C19.152 5.09109 15.8431 1.74988 11.7498 1.74988C7.65655 1.74988 4.34766 5.09109 4.34766 9.20112ZM11.7498 15.1524C8.49535 15.1524 5.84766 12.4931 5.84766 9.20112C5.84766 5.90911 8.49535 3.24988 11.7498 3.24988C15.0043 3.24988 17.652 5.90911 17.652 9.20112C17.652 12.4931 15.0043 15.1524 11.7498 15.1524Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M17.652 9.20112C17.652 10.2632 18.5085 11.1339 19.5763 11.1339 20.644 11.1339 21.5 10.2635 21.5 9.20144 21.5 8.13934 20.644 7.26879 19.5763 7.26879 18.5085 7.26879 17.652 8.13902 17.652 9.20112zM19.5763 9.63393C19.3473 9.63393 19.152 9.44521 19.152 9.20112 19.152 8.95703 19.3473 8.76879 19.5763 8.76879 19.8052 8.76879 20 8.95736 20 9.20144 20 9.44553 19.8052 9.63393 19.5763 9.63393zM2 9.20144C2 10.2635 2.8562 11.1339 3.92391 11.1339 4.99163 11.1339 5.84766 10.2632 5.84766 9.20112 5.84766 8.13902 4.99163 7.26879 3.92391 7.26879 2.8562 7.26879 2 8.13934 2 9.20144zM3.92391 9.63393C3.695 9.63393 3.5 9.44553 3.5 9.20144 3.5 8.95736 3.695 8.76879 3.92391 8.76879 4.15283 8.76879 4.34766 8.95703 4.34766 9.20112 4.34766 9.44521 4.15283 9.63393 3.92391 9.63393zM11.75 22.25C12.1642 22.25 12.5 21.9142 12.5 21.5V18.2676C12.5 17.8534 12.1642 17.5178 11.75 17.5178 11.3358 17.5178 11 17.8534 11 18.2676V21.5C11 21.9142 11.3358 22.25 11.75 22.25z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M6.30469 21.5C6.30469 21.9142 6.64047 22.25 7.05469 22.25H16.446C16.8602 22.25 17.196 21.9142 17.196 21.5 17.196 21.0858 16.8602 20.75 16.446 20.75H7.05469C6.64047 20.75 6.30469 21.0858 6.30469 21.5zM8.17768 11.1282C8.47165 11.42 8.94652 11.4183 9.23833 11.1243L13.6654 6.66451C13.9572 6.37054 13.9555 5.89567 13.6615 5.60386 13.3676 5.31204 12.8927 5.31379 12.6009 5.60776L8.17378 10.0676C7.88196 10.3615 7.88371 10.8364 8.17768 11.1282zM10.4863 12.1464C10.7802 12.4382 11.2551 12.4365 11.5469 12.1425L14.6774 8.98898C14.9692 8.69501 14.9674 8.22014 14.6735 7.92833 14.3795 7.63651 13.9046 7.63826 13.6128 7.93223L10.4824 11.0858C10.1906 11.3797 10.1923 11.8546 10.4863 12.1464z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
